<template>
  <el-dialog title="跟进" :visible.sync="visible" width="50%">
    <FollowAdd v-if="visible" :targetId="targetId" :targetType="targetType" :businessStageCode="businessStageCode" @success="handleAddFollow"></FollowAdd>
    <div style="height: 461px">
      <FollowList v-if="visible" :targetId="targetId" :targetType="targetType" ref="followListRef"></FollowList>
    </div>
  </el-dialog>
</template>

<script>
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";

export default {
  name: "FollowAddDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      targetType: null,
      targetId: null,
      businessStageCode: null
    };
  },
  created() {
  },
  components: {
    FollowList,
    FollowAdd
  },
  watch: {
    visible (val) {
      if (!val) {
        this.targetId = null;
      }
    }
  },
  methods: {
    open (targetType, targetId, businessStageCode) {
      this.targetType = targetType;
      this.targetId = targetId;
      this.businessStageCode = businessStageCode;
      this.visible = true;
    },
    handleAddFollow () {
      this.visible = false;
      this.$emit('success');
    }
  }
};
</script>
